import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { GraduationCap, ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * "New to this topic?" — optional starting points shown only on advanced
 * investigations. Every recommendation is resolved server-side against
 * published content, so links are never broken.
 */
export const NewToThisTopic = () => {
  const { pathname } = useLocation();
  const [data, setData] = useState(null);

  useEffect(() => {
    let dead = false;
    setData(null);
    axios.get(`${API}/learning/starters`, { params: { path: pathname } })
      .then((r) => { if (!dead) setData(r.data); })
      .catch(() => { if (!dead) setData({ show: false }); });
    return () => { dead = true; };
  }, [pathname]);

  if (!data?.show) return null;

  return (
    <section
      className="max-w-6xl mx-auto px-4 md:px-8 py-10 md:py-12"
      data-testid="new-to-topic-section"
    >
      <div className="border p-5 md:p-6" style={{ borderColor: "#2D2A26", background: "#0F0E12" }}>
        <div className="flex items-center gap-2">
          <GraduationCap size={13} className="text-[#A68F5E]" />
          <span className="font-mono text-[10px] uppercase tracking-[0.5em] text-[#A68F5E]">
            New to this topic?
          </span>
        </div>
        <p className="text-[12px] text-[#8A8377] mt-2">
          This is an advanced investigation. Recommended starting points:
        </p>
        <ul className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-2">
          {data.items.map((it) => (
            <li key={it.url}>
              <Link
                to={it.url}
                data-testid={`starter-${it.url.split("/").pop()}`}
                className="group flex items-start gap-3 border p-3 hover:border-[#A68F5E] transition-colors"
                style={{ borderColor: "#221F1B", background: "#12110E" }}
              >
                <div className="flex-1 min-w-0">
                  <div className="font-mono text-[7.5px] uppercase tracking-[0.25em] text-[#5A554C]">
                    {it.type_label}
                  </div>
                  <div className="text-[13px] text-[#E4DFD3] font-heading leading-tight mt-0.5 group-hover:text-[#A68F5E] transition-colors">
                    {it.title}
                  </div>
                  <div className="text-[11px] text-[#7B7168] mt-1">{it.note}</div>
                </div>
                <ArrowUpRight size={12} className="text-[#454038] group-hover:text-[#A68F5E] shrink-0 mt-1 transition-colors" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
